/**
 * The Module → Entity cascade on the Business Rule form: only entities with a declared rule
 * context can carry a tenant rule (the condition editor's fields and the engine's input come
 * from that context), so both pickers read the rule-context registry, not the entity registry.
 */
export interface RuleContextEntity {
  entityName: string;
  moduleName: string;
}

/** Distinct module names owning at least one rule-context entity, sorted. */
export function modulesOf(entities: readonly RuleContextEntity[]): string[] {
  return Array.from(new Set(entities.map((e) => e.moduleName))).sort((a, b) => a.localeCompare(b));
}

/** The rule-context entities of one module, sorted by name. Empty when no module is chosen. */
export function entitiesIn(entities: readonly RuleContextEntity[], module: string | undefined): RuleContextEntity[] {
  if (!module) return [];
  return entities
    .filter((e) => e.moduleName === module)
    .sort((a, b) => a.entityName.localeCompare(b.entityName));
}
